import { render } from "./CreateOrderClientModal.vue?vue&type=template&id=2963859d"
import script from "./CreateOrderClientModal.vue?vue&type=script&lang=js"
export * from "./CreateOrderClientModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__